import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { EventRequest, EventResponse, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/event
 * p95 target < 200ms (publishImmediate mode).
 */
export function useEventDemo() {
  return useMutation<EventResponse, ApiError, EventRequest>({
    mutationFn: (req) => showcaseApi.event(req),
    mutationKey: ['common-showcase', 'event'],
  });
}
